import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=53555186&scoped=true&"
var script = {}
import style0 from "./Offline.vue?vue&type=style&index=0&id=53555186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53555186",
  null
  
)

export default component.exports